<template>
  <svg v-if="color_1"
       width="20"
       height="20"
       viewBox="0 0 20 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 18C1.45 18 0.979333 17.8043 0.588 17.413C0.196667 17.0217 0.000666667 16.5507 0 16V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196667 1.45067 0.000666667 2 0H16C16.55 0 17.021 0.196 17.413 0.588C17.805 0.98 18.0007 1.45067 18 2V10.35C17.6833 10.2333 17.3583 10.146 17.025 10.088C16.6917 10.03 16.35 10.0007 16 10V2H2V16H10C10 16.35 10.0293 16.6917 10.088 17.025C10.1467 17.3583 10.234 17.6833 10.35 18H2ZM16 20L14.6 18.6L16.175 17H12V15H16.175L14.6 13.4L16 12L20 16L16 20ZM8 14H10V10H14V8H10V4H8V8H4V10H8V14Z"
      fill="url(#ai_convo_gradient)" />
    <defs>
      <linearGradient id="ai_convo_gradient"
                      x1="10"
                      y1="0"
                      x2="10"
                      y2="20"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color_1" />
        <stop offset="1" :stop-color="color_2" />
      </linearGradient>
    </defs>
  </svg>
  <svg v-else
       width="20"
       height="20"
       viewBox="0 0 20 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 18C1.45 18 0.979333 17.8043 0.588 17.413C0.196667 17.0217 0.000666667 16.5507 0 16V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196667 1.45067 0.000666667 2 0H16C16.55 0 17.021 0.196 17.413 0.588C17.805 0.98 18.0007 1.45067 18 2V10.35C17.6833 10.2333 17.3583 10.146 17.025 10.088C16.6917 10.03 16.35 10.0007 16 10V2H2V16H10C10 16.35 10.0293 16.6917 10.088 17.025C10.1467 17.3583 10.234 17.6833 10.35 18H2ZM16 20L14.6 18.6L16.175 17H12V15H16.175L14.6 13.4L16 12L20 16L16 20ZM8 14H10V10H14V8H10V4H8V8H4V10H8V14Z"
      :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#899399"
    },
    color_1: null,
    color_2: null
  }
}
</script>
